export enum Audience {
  Patients = 1,
  Practitioners = 2,
  All = Audience.Patients | Audience.Practitioners
}
